<div class="container-fluid">
  <div class="row">
     <div class="alignMenu shadow text-left pt-2 px-1" [ngClass]="companyId == 36 ? 'col-md-3 col-lg-2' : 'col-lg-2 col-xl-2'">
      <app-rental-menu (companyIdSevenMile)="companyIdSevenMile($event)"></app-rental-menu>
    </div>
    <div class="bgMainSection bgBlue text-left" [ngClass]="companyId == 36 ? 'col-md-9 col-lg-10' : 'col-lg-10 col-xl-10'" [formGroup]="VendorAppForm">
      <div class="container mainContainer">
        <div class="row">
          <div class="col-5 text-left mt-4">
            <label class="mainHeading">Vendor Application</label>
          </div>
          <div class="col-7 text-right mt-4">
            <label class="mainHeading">{{this.marketName}}</label>
          </div>
        </div>
        <div class="bgWghite shadow pt-2 mt-2">
          <div class="container">
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-start mt-3">
                <label class="mb-0">*First Name:</label>
                <input type="text" class="form-control" formControlName="FirstName" [appAutoCase]="formatId">
                <small style="color: #D7232C;" *ngIf="VendorAppForm.get('FirstName').hasError('required')" i18n>* required </small>
                <small style="color: #D7232C;" *ngIf="VendorAppForm.get('FirstName').hasError('maxlength')" i18n>* max length exceeded
                </small>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-start mt-3" *ngIf="this.VendorGeneralSetting.VendorNameFormat.includes('Middle Name')">
                <label class="mb-0">Middle Name:</label>
                <input type="text" class="form-control" formControlName="MiddleName" [appAutoCase]="formatId">
                <small style="color: #D7232C;" *ngIf="VendorAppForm.get('MiddleName').hasError('maxlength')" i18n>* max length exceeded
                </small>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-start mt-3" *ngIf="this.VendorGeneralSetting.VendorNameFormat.includes('Last Name')">
                <label class="mb-0"><span *ngIf="LastNameMandatory">*</span>Last Name:</label>
                <input type="text" class="form-control" formControlName="LastName" [appAutoCase]="formatId">
                <small style="color: #D7232C;" *ngIf="VendorAppForm.get('LastName').hasError('maxlength')" i18n>* max length exceeded
                </small>
                <small style="color: #D7232C;" *ngIf="VendorAppForm.get('LastName').hasError('required')" i18n>* required </small>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-start mt-3">
                <label class="mb-0"><span *ngIf="AddressMandatory">*</span>Address:</label>
                <input type="text" class="form-control" formControlName="Address">
                <small style="color: #D7232C;" *ngIf="VendorAppForm.get('Address').hasError('maxlength')" i18n>* max length exceeded </small>
                <small style="color: #D7232C;" *ngIf="VendorAppForm.get('Address').hasError('required')" i18n>* required </small>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-start mt-3">
                <label class="mb-0">*Country:</label>
                <select id="ddlCountry" class="form-control" formControlName="Country" (change)="DropDownCountryChange($event)" translate="no">
                  <option *ngFor="let ct of countryList" [value]="ct.Name">{{ct.Name}}</option>
                </select>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-start mt-3">
                <label class="mb-0"><span *ngIf="AddressMandatory">*</span>ZipCode:</label>
                <ejs-maskedtextbox [mask]="ZipCodeMask" *ngIf="showZipCodeAsTxt" name="ZipCode" id="ZipCode" formControlName="ZipCode"
                  (blur)="UpdateStateAndCityByZipcode()"></ejs-maskedtextbox>
                <input type="text" *ngIf="!showZipCodeAsTxt" class="form-control" formControlName="ZipCode"
                  (blur)="UpdateStateAndCityByZipcode()">
                  <small style="color: #D7232C;" *ngIf="VendorAppForm.get('ZipCode')?.hasError('required')" i18n>* required </small>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-start mt-3">
                <label class="mb-0"><span *ngIf="AddressMandatory">*</span>City:</label>
                <input type="text" class="form-control" formControlName="City" [appAutoCase]="caseCode">
                <small style="color: #D7232C;" *ngIf="VendorAppForm.get('City')?.hasError('required')" i18n>* required </small>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-start mt-3">
                <label class="mb-0"><span *ngIf="AddressMandatory">*</span>State:</label>
                  <ejs-combobox id='StateCombobox' #State *ngIf="showStateDropDown" [fields]='DropDownfieldsState' [popupHeight]="200"
                    [dataSource]='StateList' formControlName="State" [allowFiltering]='true' allowCustom=true
                    placeholder='' (created)="lockStateComboBoxTranslation()" (open)="lockStateComboBoxTranslation()"></ejs-combobox>

                  <input type="text" *ngIf="!showStateDropDown" maxlength="2" class="form-control" formControlName="State">

                <small style="color: #D7232C;" *ngIf="VendorAppForm.get('State')?.hasError('required')" i18n>* required </small>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-start mt-3">
                <label class="mb-0"><span *ngIf="WorkPhoneMandatory">*</span>Work Phone:</label>
                <ejs-maskedtextbox [mask]="PhoneNumberMask" name="WorkPhone" id="WorkPhone"
                  formControlName="WorkPhone"></ejs-maskedtextbox>
                <small style="color: #D7232C;" *ngIf="VendorAppForm.get('WorkPhone')?.hasError('required')" i18n>* required </small>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-start mt-3">
                <label class="mb-0"><span *ngIf="WorkPhoneMandatory">*</span>Cell Phone:</label>
                <ejs-maskedtextbox [mask]="PhoneNumberMask" name="CellPhone" id="CellPhone"
                  formControlName="CellPhone">
                </ejs-maskedtextbox>
                <small style="color: #D7232C;" *ngIf="VendorAppForm.get('CellPhone')?.hasError('minlength')" i18n>* invalid Cell Phone
                  Number</small>
                <small style="color: #D7232C;" *ngIf="VendorAppForm.get('CellPhone')?.hasError('required')" i18n>* required </small>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-start mt-3">
                <label class="mb-0"><span *ngIf="EmailMandatory">*</span>Email:</label>
                <input type="email" class="form-control" formControlName="Email">
                <small style="color: #D7232C;" *ngIf="VendorAppForm.get('Email')?.hasError('required')" i18n>* required </small>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-start mt-3">
                <label class="mb-0">*Selling Product:</label>
                <ejs-combobox id="ProductPriority" [dataSource]="productList" [fields]="ProductDropDownfields" [popupHeight]="200"
                  formControlName="ProductPriority" (valueChange)="primaryproductchange($event)" [allowCustom]="false"></ejs-combobox>
                  <small style="color: #D7232C;" *ngIf="VendorAppForm.get('ProductPriority')?.invalid" i18n>*
                    required</small>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-start mt-3">
                <label class="mb-0">*How did you hear about us?</label>
                <select class="form-control" formControlName="AboutUs">
                  <option value="On site signage">On site signage</option>
                  <option value="Yellow Pages">Yellow Pages</option>
                  <option value="Bus bench">Bus bench</option>
                  <option value="Newspaper ad">Newspaper ad</option>
                  <option value="TV commercial">TV commercial</option>
                  <option value="Direct mail piece">Direct mail piece</option>
                  <option value="Coupon shopper">Coupon shopper</option>
                  <option value="Newspaper Insert">Newspaper Insert</option>
                  <option value="Networking">Networking</option>
                </select>
                <small style="color: #D7232C;" *ngIf="VendorAppForm.get('AboutUs').invalid" i18n>*
                  required</small>
              </div>
              <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 text-start mt-3">
                <label class="mb-0">Rental Type Intrested in: </label>
                <ul class="Receipt-list mt-2">
                  <li>
                    <div class="form-check d-flex align-items-center" *ngIf="AllowBookingsDaily">
                      <input class="form-check-input CheckboxClass" type="checkbox" id="chkDaily" formControlName="Daily" >
                      <label class="form-check-label ml-2 mt-1" for="chkDaily" i18n>
                        Daily
                      </label>
                    </div>
                  </li>
                  <li>
                    <div class="form-check d-flex align-items-center" *ngIf="AllowBookingsMonthly">
                      <input class="form-check-input CheckboxClass" type="checkbox" id="chkMonthly" formControlName="Monthly" >
                      <label class="form-check-label ml-2 mt-1" for="chkMonthly" i18n>
                        Monthly
                      </label>
                    </div>
                  </li>
                  <li>
                    <div class="form-check d-flex align-items-center" *ngIf="AllowBookingsWeekly">
                      <input class="form-check-input CheckboxClass" type="checkbox" id="chkWeekly" formControlName="Weekly" >
                      <label class="form-check-label ml-2 mt-1" for="chkWeekly" i18n>
                        Weekly
                      </label>
                    </div>
                  </li>
                  <li>
                    <div class="form-check d-flex align-items-center" *ngIf="AllowBookingsCm">
                      <input class="form-check-input CheckboxClass" type="checkbox" id="chkCombinedMonthly" formControlName="CombinedMonthly">
                      <label class="form-check-label ml-2 mt-1" for="chkCombinedMonthly" i18n>
                        Combined Monthly
                      </label>
                    </div>
                  </li>
                  <li>
                    <div class="form-check d-flex align-items-center" *ngIf="AllowBookingsCw">
                      <input class="form-check-input CheckboxClass" type="checkbox" id="chkCombinedWeekly" formControlName="CombinedWeekly">
                      <label class="form-check-label ml-2 mt-1" for="chkCombinedWeekly" i18n>
                        Combined Weekly
                      </label>
                    </div>
                  </li>
                </ul>
                <ul class="Receipt-list mt-3">
                  <!-- <li>
                    <div class="form-check d-flex align-items-center">
                      <input class="form-check-input CheckboxClass" type="checkbox" id="chkReqElectricity" formControlName="IsElectricityRequired">
                      <label class="form-check-label ml-2 mt-1" for="chkReqElectricity" i18n>
                        Required Electricity
                      </label>
                    </div>
                  </li> -->
                  <li>
                    <div class="form-check d-flex align-items-center">
                      <input class="form-check-input CheckboxClass" type="checkbox" id="chkPermanentVendor" formControlName="PermanentVendor">
                      <label class="form-check-label ml-2 mt-1" for="chkPermanentVendor" i18n>
                        Intrested in becoming a Permanent Vendor
                      </label>
                    </div>
                  </li>
                </ul>
              </div>

              <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 text-start mt-3">
                <label class="mb-0">Space Required By</label>
                <ejs-datepicker #fromDate format='MM/dd/yyyy' tabindex="0" [allowEdit]=false formControlName="SpaceRequiredByDate"
                   (renderDayCell)="onRenderDayCell($event)" [min]="minDate" [showTodayButton]="false"
                  ></ejs-datepicker>
              </div>
            </div>
            <div *ngFor="let rule of rulesFormArray; let i = index">
              <div class="row">
                <div class="col-12 text-left mt-2">
                  <div>
                    <input type="checkbox" class="CheckboxClass mt-3" [formControlName]="isChecked" [id]="'checkbox_' + i"
                      (change)="updateArrayDirectly(i, $event)">

                    <label class="chkAlign mb-0" [for]="'checkbox_' + i">
                      {{ rule.rulesAndRegualtions }}
                    </label>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="rule.AgreementLinkRequired">
                <div class="col-12 text-left mt-1">
                  <img
                    src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMS4xMjQiIGhlaWdodD0iMTUuODQzIiB2aWV3Qm94PSIwIDAgMjEuMTI0IDE1Ljg0MyI+CiAgPHBhdGggaWQ9Ikljb25fYXdlc29tZS1oYW5kLXBvaW50LXJpZ2h0IiBkYXRhLW5hbWU9Ikljb24gYXdlc29tZS1oYW5kLXBvaW50LXJpZ2h0IiBkPSJNMjEuMTI0LDEwLjFBMS44NiwxLjg2LDAsMCwxLDE5LjI3NiwxMS45aC00LjEyYTIuMDI5LDIuMDI5LDAsMCwxLS4yNiwyLjkyNywxLjg5LDEuODksMCwwLDEtLjY3OSwyLjU3MWMuMzcsMi4wMjctLjkwNSwyLjk0LTMsMi45NC0uMTEzLDAtLjU0OC0uMDA4LS42Ni0uMDA4LTIuNTU3LjAwNy0zLjE3Mi0xLjI4Mi01LjEtMS41ODFhLjk4OS45ODksMCwwLDEtLjgzNi0uOTc4VjEwLjdoMEExLjk4LDEuOTgsMCwwLDEsNS44LDguODljMS4xOTItLjUzNiwzLjkzNy0yLjAyMyw0LjQzNy0zLjE5YTEuNzU5LDEuNzU5LDAsMCwxLDEuNjUtMS4yQTEuOTgyLDEuOTgyLDAsMCwxLDEzLjcsNy4yNmE1LjYwOCw1LjYwOCwwLDAsMS0uNTg0LDEuMDI4aDYuMTU3QTEuODksMS44OSwwLDAsMSwyMS4xMjQsMTAuMVptLTE3LjE2My4wMTR2Ny45MjJhLjk5Ljk5LDAsMCwxLS45OS45OUguOTlhLjk5Ljk5LDAsMCwxLS45OS0uOTlWMTAuMTExYS45OS45OSwwLDAsMSwuOTktLjk5aDEuOThBLjk5Ljk5LDAsMCwxLDMuOTYxLDEwLjExMVpNMi44MDYsMTcuMDQyYS44MjUuODI1LDAsMSwwLS44MjUuODI1QS44MjUuODI1LDAsMCwwLDIuODA2LDE3LjA0MloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgLTQuNSkiIGZpbGw9IiMwNzI4ZmYiLz4KPC9zdmc+Cg=="
                    class="img-fluid" />
                  &nbsp;<a [href]="rule.AgreementBlobURL" target="_blank" class="rules">{{rule.AgreementLinkTextContent}}</a>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-right mt-2 mb-3">
                <button class="btn btn-outline-primary mr-1" (click)="Cancel()">Cancel</button>
                <button class="btn btn-primary" (click)="onSubmit()" [disabled]="!allCheckboxesCheckedValidator()">Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
